import ReactDOM from 'react-dom'
import videojs from 'video.js'
import React from 'react'
import Switch from 'react-bootstrap-switch'
import axiosInstance from 'api/axios.config'

const vjsComponent = videojs.getComponent('Component')

class Autoplay extends vjsComponent {
  constructor (player, options) {
    super(player, options)

    this.autoplayActive = options.autoplay
    this.mountElement = this.mountElement.bind(this)
    this.createAutoplaySwitch = this.createAutoplaySwitch.bind(this)

    player.ready(() => {
      this.mountElement()
    })

    /* Remove React root when component is destroyed */
    this.on('dispose', () => {
      ReactDOM.unmountComponentAtNode(this.el())
    })
  }

  mountElement () {
    ReactDOM.render(this.createAutoplaySwitch(), this.el())
  }

  handleAutoplayChange () {
    axiosInstance.post('/preferences/toggle_autoplay').catch(e => {
      console.error(e.message)
    })
  }

  createAutoplaySwitch () {
    let autoplayText = <span className='vjs-autoplay-text'>Autoplay</span>

    return (
      <React.Fragment>
        {autoplayText}
        <div className='vjs-autoplay-toggle'>
          <Switch
            onChange={this.handleAutoplayChange}
            bsSize='mini'
            labelWidth={11}
            defaultValue={this.autoplayActive}
          />
        </div>
      </React.Fragment>
    )
  }
}

vjsComponent.registerComponent('Autoplay', Autoplay)

export default Autoplay
